"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { BLOG_CATEGORY_ORDER, catAnchorId, categoryPathSegment } from "@/lib/blog/categoryNav";

/**
 * Compact category navigation — jumps to anchors on the Insights index.
 */
export function BlogCategoriesDropdown() {
  const pathname = usePathname();
  const base = pathname === "/blog" ? "" : "/blog";

  return (
    <details className="ed-blog-cat-dd">
      <summary className="ed-blog-cat-dd__summary" aria-label="Browse categories">
        Categories
      </summary>
      <div className="ed-blog-cat-dd__panel" role="presentation">
        <p className="ed-blog-cat-dd__hint">Shareable topic pages — or jump on the full hub</p>
        <ul className="ed-blog-cat-dd__list">
          {BLOG_CATEGORY_ORDER.map((c) => (
            <li key={c}>
              <Link href={`/blog/category/${categoryPathSegment(c)}`} className="ed-blog-cat-dd__link">
                {c}
              </Link>
              <Link href={`${base}#${catAnchorId(c)}`} className="ed-blog-cat-dd__hash" title={`Jump to ${c} on hub`}>
                #
              </Link>
            </li>
          ))}
          <li>
            <Link href="/blog/clusters" className="ed-blog-cat-dd__link ed-blog-cat-dd__link--sub">
              Cluster hubs
            </Link>
          </li>
        </ul>
      </div>
    </details>
  );
}
